import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useNavigate } from "react-router-dom";

const EmailVerificationGuard: FC<{
  children: React.ReactElement;
  verified?: boolean;
}> = ({ children, verified = true }) => {
  const userVerified = useSelector(
    (state: RootState) => state.auth.user?.verified,
  );
  const email = useSelector((state: RootState) => state.signUp.email);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userVerified && verified && email) {
      navigate("/verify-email");
    }
    if (userVerified && !verified) {
      navigate("/");
    }
    if (!userVerified && !email && !verified) {
      navigate("/sign-in");
    }
  }, [navigate, userVerified, verified, email]);

  if (!userVerified && verified && email) {
    return null;
  }
  if (userVerified && !verified) {
    return null;
  }

  if (!userVerified && !email && !verified) {
    return null;
  }

  return children;
};

export default EmailVerificationGuard;
